import { isMobile } from 'react-device-detect';
import { preloadQRCodesCache } from '../devices/actions';
import { notification } from '../notification/actions';

export function callEndpointsForOfflineModeOnMobile(dispatch, t, forcingStrategy = null) {
    if (isMobile) {
        dispatch(preloadQRCodesCache(forcingStrategy));

        if (forcingStrategy) {
            dispatch(notification(
                t('notifications:synchronize_qrcodes_inprogress'),
                'successful',
                'infoCircle'
            ));
        }
    }
}


export const sendMessageToServiceWorker = (wb, msg) => wb.messageSW(msg);
